import axios, { API_URL } from './BaseService';

export async function createInviteCode(expiresInDays = null) {
    const response = await axios.post(`${API_URL}/invite-codes`, { expiresInDays });
    return response.data;
}

export async function validateInviteCode(code) {
    const response = await axios.post(`${API_URL}/invite-codes/validate`, { code });
    return response.data;
}

export async function getMyInviteCodes() {
    const response = await axios.get(`${API_URL}/invite-codes/my`);
    return response.data;
}

export async function getAllInviteCodes(page = 1, pageSize = 10) {
    const response = await axios.get(`${API_URL}/invite-codes?page=${page}&pageSize=${pageSize}`);
    return response.data;
}








